import { useMutation, useQueryClient } from '@tanstack/react-query';
import useModal from '../../components/partials/Modal/useModal';
import { toastError, toastSuccess } from '../../components/partials/Toast/Toast';
import useApiStore from '../../store/useApiStore';
import { CAMPAIGNS_KEY } from '../../utils/constants';
import Api from '../Api';
import { ICampaign, ICampaignQueryLog } from '../../types';

interface RESPONSE {
  campaign: ICampaign;
  campaignQueryLog: ICampaignQueryLog;
  message: string;
}

export default function useRunCampaign() {
  const { onError } = useApiStore();
  const queryClient = useQueryClient();
  const { hideModal } = useModal();

  return useMutation({
    mutationFn: async (payload: string) => {
      const api = new Api({ onError });

      const data: RESPONSE = await api.post<RESPONSE>({
        url: `api/v1/campaigns/${payload}/run`,
        payload,
      });

      return data;
    },
    onSuccess: (data) => {
      let message = 'Successfully run campaign.';
      if(data.message) {
        message = data.message;
      }

      toastSuccess(message);

      queryClient.invalidateQueries({ queryKey: [CAMPAIGNS_KEY] });

      hideModal();
    },
    onError: () => {
      toastError('Error in running the campaign.');

      queryClient.invalidateQueries({ queryKey: [CAMPAIGNS_KEY] });

      hideModal();
    }
  });
}
